<template>

    <m-edit1/>

    <m-factor-10 v-bind='{...{"showLogo":true,"showSiteNameInsteadOfLogo":false,"showDeliveryOption":true,"showCartonSize":true,"showOrderFormAnswers":true},...{}}' :style='""' class="" ></m-factor-10>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mFactor10 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor10';

export default {
    name: 'HomeView',
    components: {mEdit1, mFactor10 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
